import React, { useState } from "react"
import iceberg_picture from "./iceberg.svg"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import { FloatingImg, FlexAlignCenter } from "./style"
import Popup from "reactjs-popup"
import "reactjs-popup/dist/index.css"

const randomQuotes = [
  "“The best error message is the one that never shows up.” - Thomas Fuchs",
  "“Testing leads to failure, and failure leads to understanding.” - Burt Rutan",
  "“The only way to learn a new programming language is by writing programs in it.” - Dennis Ritchie",
  "“Programming isn't about what you know; it's about what you can figure out.” - Chris Pine",
  "“That's the thing about people who think they hate computers. What they really hate is lousy programmers.” - Larry Niven",
  "“Talk is cheap. Show me the code.” - Linus Torvald",
  "“Any fool can write code that a computer can understand. Good programmers write code that humans can understand.” - Martin Fowler",
]

function generateRandomQuote() {
  const quote = randomQuotes[Math.floor(Math.random() * randomQuotes.length)]
  if (randomQuotes.length != 1) {
    // Only 4 quotes show up because click-down and click-down pop the quote
    // only every second click-down shows the popup
    randomQuotes.pop(quote)
  }
  return quote
}

const FloatingIceberg = () => {
  const [wish, setWish] = useState()

  const handleClick = () => {
    trackCustomEvent({
      category: "Show Quote",
      action: "Click",
    })
    setWish(generateRandomQuote())
  }

  return (
    <FlexAlignCenter>
      <Popup
        trigger={
          <FlexAlignCenter>
            <FloatingImg onClick={handleClick} src={iceberg_picture} />
          </FlexAlignCenter>
        }
        position="top center"
      >
        <FlexAlignCenter>{wish}</FlexAlignCenter>
      </Popup>
    </FlexAlignCenter>
  )
}

export default FloatingIceberg
